var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-info-wrapper",
    { attrs: { company: _vm.company, "no-scroll": "" } },
    [
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            { attrs: { shrink: "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v("Referred by")]),
                      _c("w-card-content", [
                        !_vm.referredBy
                          ? _c("p", { staticClass: "muted" }, [
                              _vm._v(
                                " This account was not referred by anyone. "
                              ),
                            ])
                          : _c(
                              "p",
                              [
                                _c(
                                  "w-link",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToCompany(
                                          _vm.referredBy.referrerCompanyId
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.referredBy.referrerCompanyName ||
                                            "#" +
                                              _vm.referredBy.referrerCompanyId
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("span", { staticClass: "muted" }, [
                                  _vm._v(
                                    " · " +
                                      _vm._s(
                                        _vm.formatDate(
                                          _vm.referredBy.dateCreated
                                        )
                                      )
                                  ),
                                ]),
                              ],
                              1
                            ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { shrink: "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(
                          "Brought in (" + _vm._s(_vm.broughtIn.length) + ")"
                        ),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _vm.broughtIn.length == 0
                            ? _c("p", { staticClass: "muted" }, [
                                _vm._v(
                                  " This account has not referred anyone yet. "
                                ),
                              ])
                            : _c(
                                "w-list",
                                [
                                  _c(
                                    "w-list-item",
                                    [
                                      _c("w-list-item-text", [
                                        _vm._v("Account"),
                                      ]),
                                      _c("w-list-item-text", [_vm._v("Date")]),
                                      _c("w-list-item-text", [
                                        _vm._v("Rewarded"),
                                      ]),
                                      _c("w-list-item-text", {
                                        staticClass: "right-align",
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._l(_vm.broughtIn, function (r) {
                                    return _c(
                                      "w-list-item",
                                      { key: r.id },
                                      [
                                        _c(
                                          "w-list-item-text",
                                          [
                                            _c(
                                              "w-link",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.goToCompany(
                                                      r.referredCompanyId
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      r.referredCompanyName ||
                                                        "#" +
                                                          r.referredCompanyId
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("w-list-item-text", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(r.dateCreated)
                                            )
                                          ),
                                        ]),
                                        _c("w-list-item-text", [
                                          r.rewarded
                                            ? _c(
                                                "span",
                                                { staticClass: "badge" },
                                                [_vm._v("Rewarded")]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "muted" },
                                                [_vm._v("No")]
                                              ),
                                        ]),
                                        _c(
                                          "w-list-item-text",
                                          { staticClass: "right-align" },
                                          [
                                            _c(
                                              "w-button",
                                              {
                                                attrs: { small: "", flat: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openReward(r)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      r.rewarded
                                                        ? "Edit reward"
                                                        : "Mark rewarded"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { shrink: "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(
                          "Invites sent (" + _vm._s(_vm.invites.length) + ")"
                        ),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _vm.invites.length == 0
                            ? _c("p", { staticClass: "muted" }, [
                                _vm._v(
                                  " This account has not sent any email invites. "
                                ),
                              ])
                            : _c(
                                "w-list",
                                [
                                  _c(
                                    "w-list-item",
                                    [
                                      _c("w-list-item-text", [_vm._v("Email")]),
                                      _c("w-list-item-text", [
                                        _vm._v("Date sent"),
                                      ]),
                                      _c("w-list-item-text", [
                                        _vm._v("Status"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._l(_vm.invites, function (i) {
                                    return _c(
                                      "w-list-item",
                                      { key: "invite-" + i.id },
                                      [
                                        _c("w-list-item-text", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "mailto:" + i.email,
                                              },
                                            },
                                            [_vm._v(_vm._s(i.email))]
                                          ),
                                        ]),
                                        _c("w-list-item-text", [
                                          _vm._v(
                                            _vm._s(_vm.formatDate(i.dateSent))
                                          ),
                                        ]),
                                        _c("w-list-item-text", [
                                          i.status == "registered"
                                            ? _c(
                                                "span",
                                                { staticClass: "badge" },
                                                [_vm._v("Registered")]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "muted" },
                                                [_vm._v("Sent")]
                                              ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { value: _vm.selected != null, "escape-close": "" },
          on: {
            input: function ($event) {
              _vm.selected = null
            },
          },
        },
        [
          _vm.selected
            ? _c(
                "w-card",
                { staticClass: "reward-card" },
                [
                  _c("w-card-title", [_vm._v("Reward referral")]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "div",
                        { staticClass: "referral-flow" },
                        [
                          _c("div", { staticClass: "flow-party" }, [
                            _c("span", { staticClass: "flow-label" }, [
                              _vm._v("Referrer"),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.selected.referrerCompanyName ||
                                    _vm.company.name
                                )
                              ),
                            ]),
                          ]),
                          _c("w-fa", {
                            staticClass: "flow-arrow",
                            attrs: { icon: "arrow-right" },
                          }),
                          _c(
                            "div",
                            { staticClass: "flow-party" },
                            [
                              _c("span", { staticClass: "flow-label" }, [
                                _vm._v("Brought in"),
                              ]),
                              _c(
                                "w-link",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToCompany(
                                        _vm.selected.referredCompanyId
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.selected.referredCompanyName ||
                                          "#" + _vm.selected.referredCompanyId
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("p", { staticClass: "flow-meta" }, [
                        _vm._v(
                          " Referred on " +
                            _vm._s(_vm.formatDate(_vm.selected.dateCreated)) +
                            " · code " +
                            _vm._s(_vm.selected.code) +
                            " "
                        ),
                      ]),
                      _c("w-divider"),
                      _c("w-switch", {
                        staticClass: "reward-switch",
                        attrs: { label: "Rewarded", space: "" },
                        model: {
                          value: _vm.rewarded,
                          callback: function ($$v) {
                            _vm.rewarded = $$v
                          },
                          expression: "rewarded",
                        },
                      }),
                      _vm.selected.rewardedAt
                        ? _c("p", { staticClass: "flow-meta" }, [
                            _vm._v(
                              " Rewarded on " +
                                _vm._s(
                                  _vm.formatDate(_vm.selected.rewardedAt)
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c("w-input", {
                        attrs: { label: "Note (internal)", fancy: "" },
                        model: {
                          value: _vm.note,
                          callback: function ($$v) {
                            _vm.note = $$v
                          },
                          expression: "note",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              _vm.selected = null
                            },
                          },
                        },
                        [_vm._v(" Cancel ")]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { loading: _vm.saving },
                          on: {
                            click: function ($event) {
                              return _vm.saveReward()
                            },
                          },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }